import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getPayrollSettings = async () => {
  const res = await axiosInstance.get("/api/payroll-portal/settings");
  return res.data;
};

export const updatePayrollSettings = async (data) => {
  const res = await axiosInstance.put("/api/payroll-portal/settings", data);
  return res.data;
};
